export const BSA_MODULE_PATH = '/bsa'

export enum BSAPaths {
  BSA_CTR_BATCHES_LIST = '/bsa/ctr-batch-list'
}
